import { gql } from 'apollo-angular';

export const getMinimumWagesQuery = gql`
  query (
    $skip: Int
    $take: Int
    $tenantId: UUID!
    $where: MinimumWageDtoFilterInput
    $order: [MinimumWageDtoSortInput!]
  ) {
    minimumWages(
      skip: $skip
      take: $take
      tenantId: $tenantId
      where: $where
      order: $order
    ) {
      totalCount
      items {
        effectiveDate
        id
        jurisdiction
        jurisdictionId
        legacyProjectId
        legacyProjectLocationId
        rate
        scope
        scopeId
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
